import React from "react";
import { Link } from "react-router-dom";
import images from "../../../assets";
import { STUDENT_PORTAL_URL } from "../../../constants/Matcher";
import { yearsForStage } from "../../../constants/catalogue";
import { FREE_ASSESSMENT_URL } from "../../../constants/journey";
import { C, FONT } from "../../../constants/mq";

// Site footer, laid out like mq.edu.au: charcoal, wordmark and tagline on
// top, link columns, then a thin bottom bar.

const ADDRESS_LINES = ["Unit 121, 14 Lexington Drive", "Bella Vista NSW 2153"];
const PHONES = ["+61 2 8883 0055", "+61 2 8883 2555"];

const range = (stage) => {
  const ys = yearsForStage(stage);
  return ys.length ? `Year ${ys[0].year}–${ys[ys.length - 1].year}` : "";
};

const css = `
.cs-foot { background: ${C.ink}; color: #fff; font-family: ${FONT}; }
.cs-foot__inner { max-width: 1072px; margin: 0 auto; padding: 0 24px; }
.cs-foot__top { display: flex; align-items: center; justify-content: space-between; gap: 24px; padding: 40px 0 34px; flex-wrap: wrap; }
.cs-foot__brand { display: flex; align-items: center; gap: 12px; text-decoration: none; }
.cs-foot__brand img { height: 40px; width: auto; filter: brightness(0) invert(1); }
.cs-foot__word { display: flex; flex-direction: column; line-height: 1; color: #fff; }
.cs-foot__word b { font-size: 19px; font-weight: 700; letter-spacing: 0.2px; }
.cs-foot__word span { font-size: 9.5px; font-weight: 600; letter-spacing: 1.6px; margin-top: 5px; text-transform: uppercase; opacity: 0.85; }
.cs-foot__tag { font-size: 19px; font-weight: 600; color: #fff; margin: 0; letter-spacing: 0.1px; }
.cs-foot__cols { display: grid; grid-template-columns: repeat(5, 1fr); gap: 28px; padding-bottom: 40px; }
.cs-foot h4 { font-size: 14px; font-weight: 700; color: #fff; margin: 0 0 18px; }
.cs-foot__cols a, .cs-foot__cols p { display: block; font-size: 12.5px; line-height: 1.55; color: #fff; text-decoration: none; margin: 0 0 11px; }
.cs-foot__cols a:hover { text-decoration: underline; text-underline-offset: 3px; }
.cs-foot__bottom { border-top: 1px solid rgba(255,255,255,0.25); padding: 22px 0 30px; display: flex; flex-wrap: wrap; justify-content: space-between; gap: 14px; font-size: 12px; }
.cs-foot__bottom nav { display: flex; flex-wrap: wrap; gap: 0; }
.cs-foot__bottom nav a { color: #fff; text-decoration: none; padding: 0 10px; border-left: 1px solid rgba(255,255,255,0.45); }
.cs-foot__bottom nav a:first-child { border-left: none; padding-left: 0; }
.cs-foot__bottom nav a:hover { text-decoration: underline; }
@media (max-width: 960px) {
  .cs-foot__cols { grid-template-columns: repeat(3, 1fr); }
}
@media (max-width: 600px) {
  .cs-foot__cols { grid-template-columns: repeat(2, 1fr); }
  .cs-foot__tag { font-size: 18px; }
}
`;

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="cs-foot">
      <style>{css}</style>
      <div className="cs-foot__inner">
        <div className="cs-foot__top">
          <Link to="/" className="cs-foot__brand">
            <img {...images["cs-logo"]} alt="" />
            <span className="cs-foot__word">
              <b>CS Education</b>
            </span>
          </Link>
          {/* one weight, our own font: the bold + serif-italic mix read as
              Macquarie's "YOU to the power of us" */}
          <p className="cs-foot__tag">The right tutoring, at the right level</p>
        </div>

        <div className="cs-foot__cols">
          <div>
            <h4>Quick links</h4>
            <Link to="/our-courses">Find a course</Link>
            <Link to="/enroll">How to enrol</Link>
            <Link to="/pricing">Pricing</Link>
            <a href={FREE_ASSESSMENT_URL} target="_blank" rel="noopener noreferrer">
              Free assessment
            </a>
            <Link to="/events">Events</Link>
          </div>
          <div>
            <h4>Courses</h4>
            <Link to="/our-courses">Primary ({range("primary")})</Link>
            <Link to="/our-courses">High School ({range("high")})</Link>
            <Link to="/our-courses">Senior HSC ({range("senior")})</Link>
            <Link to="/our-courses">All courses</Link>
          </div>
          <div>
            <h4>CS Education</h4>
            <Link to="/about-us">About us</Link>
            <Link to="/our-history">Our history</Link>
            <Link to="/why-cs">Why CS</Link>
            <Link to="/our-branches">Campuses</Link>
            <Link to="/resources">Resources</Link>
          </div>
          <div>
            <h4>Students &amp; families</h4>
            <Link to="/current-students">Current students</Link>
            <a href={`${STUDENT_PORTAL_URL}/login`} target="_blank" rel="noopener noreferrer">
              Student login
            </a>
            <Link to="/contact-us">Contact us</Link>
          </div>
          <div>
            <h4>Head office</h4>
            {ADDRESS_LINES.map((l) => (
              <p key={l} style={{ marginBottom: 2 }}>{l}</p>
            ))}
            <div style={{ height: 12 }} />
            {PHONES.map((p) => (
              <a key={p} href={`tel:${p.replace(/\s/g, "")}`}>
                {p}
              </a>
            ))}
          </div>
        </div>

        <div className="cs-foot__bottom">
          <span>&copy; 2002&ndash;{year} CS Education</span>
          <nav>
            <Link to="/privacy-policy">Privacy</Link>
            <Link to="/contact-us">Contact us</Link>
            <Link to="/our-branches">Campuses</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
